import { HttpErrorResponse, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ErrorHandlerService } from '@core/services/error-handler.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  private readonly errorHandlerService = inject(ErrorHandlerService);

  intercept(req: HttpRequest<unknown>, next: HttpHandler) {
    if (!req.url.startsWith(environment.apiUrl)) {
      return next.handle(req);
    }

    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        const requestId = error.headers?.get('X-Request-Id') ?? null;
        this.errorHandlerService.handle(error, requestId);
        return throwError(() => error);
      }),
    );
  }
}
